import dayjs from "dayjs";
import React from "react";

const Print = ({ currentOrder, printRef }) => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;
  const priceSymbol = process.env.REACT_APP_PRICE_SYMBOL;
  const companyAddress = process.env.REACT_APP_COMPANY_ADDRESS;
  const companyPhone = process.env.REACT_APP_COMPANY_PHONE;
  const companyEmail = process.env.REACT_APP_COMPANY_EMAIL;
  return (
    <div>
      <div ref={printRef} className="hidden invisible">
        <div className="flex justify-center items-center">
          <div className=" m-1  bg-white  flex flex-col gap-2">
            <div className="text-center">
              {companyName && (
                <p className="text-[1.3rem] text-[#1E1E1E] font-bold">
                  {companyName}
                </p>
              )}
            </div>
            {/* Top Section */}
            <div className="w-full text-center">
              <h1 className="lg:text-[2.75rem] text-[2rem] font-bold text-[#1E1E1E]">
                Rs{" "}
                {currentOrder?.totalAmountDiscount > 0
                  ? currentOrder?.totalAmountAfterDiscount.toFixed(2)
                  : currentOrder?.totalAmount.toFixed(2)}
              </h1>
              <h2 className="text-[#0D868C] lg:text-[1rem] text-[.8rem] font-bold capitalize">
                Total paid
              </h2>
            </div>
            {/* order no */}

            <div className="w-full text-center">
              <h1 className="text-[1rem] font-bold text-[#1E1E1E]">
                <p>Invoice #{currentOrder?.orderNo}</p>
              </h1>
            </div>
            {/* customer section */}

            {/* Lower Top Section */}
            <div className="flex justify-between items-center border-y border-[#0D868C] lg:p-4 p-3">
              <p className="text-[#1E1E1E] lg:text-[12px] text-[10px] font-normal">
                Cashier:{" "}
                <span className="capitalize">{currentOrder?.cashierName}</span>
              </p>
            </div>
            {/* Middle Section */}
            <div>
              {currentOrder?.products.map((item, index) => (
                <div
                  key={item._id}
                  className={`flex items-start  w-full lg:gap-6 gap-4 p-2 ${
                    index !== 0 ? "border-t-2 border-[#000000]" : ""
                  }`}
                >
                  <div className="flex flex-col flex-1">
                    <h2 className="text-[#1E1E1E] text-[.8rem] lg:text-[1rem] font-semibold capitalize">
                      {item.name}
                    </h2>
                  </div>
                  <div className="flex items-center justify-between w-[25%] text-[#1E1E1E] text-[.8rem] lg:text-[1rem]">
                    <p className="w-[50%]">X{item.quantity}</p>
                    <p>{item.quantity * item.price}</p>
                  </div>
                </div>
              ))}
            </div>
            {/* Upper Lower Section */}
            <div>
              <p className="flex flex-col justify-between items-center lg:p-4 p-3 lg:text-[1rem] text-[.8rem] border-y-2 border-[#DEDEDE]">
                {currentOrder?.totalAmountDiscount > 0 ? (
                  <div className="flex justify-between items-center w-full">
                    <span className="text-[#1E1E1E] font-bold">Total</span>
                    <span className="text-[#1E1E1E] flex gap-3 items-center ">
                      <span className=" line-through text-[#1E1E1E]">
                        {priceSymbol}
                        {currentOrder?.totalAmount.toFixed(2)}
                      </span>
                      {priceSymbol}
                      {currentOrder?.totalAmountAfterDiscount.toFixed(2)}
                    </span>
                  </div>
                ) : (
                  <div className="flex justify-between items-center w-full">
                    <span className="text-[#1E1E1E] font-bold">Total</span>
                    <span className="text-[#1E1E1E]">
                      {priceSymbol}
                      {currentOrder?.totalAmount.toFixed(2)}
                    </span>
                  </div>
                )}
                {currentOrder?.paidAmount > 0 && (
                  <div className="flex flex-col w-full text-[.8rem]">
                    <div className="flex justify-between items-center w-full">
                      <span className="text-[#1E1E1E] font-bold capitalize">
                        {currentOrder?.amountType}
                      </span>
                      <span className="text-[#1E1E1E]">
                        {priceSymbol}
                        {currentOrder?.paidAmount.toFixed(2)}
                      </span>
                    </div>
                    {currentOrder?.totalAmountDiscount > 0 ? (
                      <div className="flex justify-between items-center w-full">
                        <span className="text-[#1E1E1E] font-bold">Paid</span>
                        <span className="text-[#1E1E1E] flex gap-3 items-center ">
                          {priceSymbol}
                          {currentOrder?.totalAmountAfterDiscount.toFixed(2)}
                        </span>
                      </div>
                    ) : (
                      <div className="flex justify-between items-center w-full">
                        <span className="text-[#1E1E1E] font-bold">Paid</span>
                        <span className="text-[#1E1E1E]">
                          {priceSymbol}
                          {currentOrder?.totalAmount.toFixed(2)}
                        </span>
                      </div>
                    )}
                    {currentOrder?.amountType.toLowerCase() === "cash" && (
                      <div className="flex justify-between items-center w-full">
                        <span className="text-[#1E1E1E] font-bold">Change</span>
                        <span className="text-[#1E1E1E]">
                          {priceSymbol}
                          {currentOrder?.returnAmount.toFixed(2)}
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </p>
            </div>
            {/* shop section */}
            <div className="text-center text-[.7rem]">
              {companyName && (
                <p className=" text-[#070707] font-bold">
                  Thank You for Visiting {companyName}
                </p>
              )}
              {companyEmail && <p>{companyEmail}</p>}

              {companyAddress && <p>{companyAddress}</p>}
              {companyPhone && <p>{companyPhone}</p>}
            </div>
            {/* Lower Section */}
            <div className="flex justify-start items-center text-[#1E1E1E]  text-[14px] lg:px-4 px-3 pb-5">
              <p>
                {dayjs(currentOrder?.createdAt).format("D /M /YYYY . h:mm A")}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Print;
